/* LumvinWood Workshop Gallery — scroll reveal (respects prefers-reduced-motion) */
(function () {
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (!motionOk || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('lw-js');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lw-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  document.querySelectorAll('.lw-reveal').forEach(function (el) {
    io.observe(el);
  });
})();

/* header slim-on-scroll */
(function () {
  var header = document.getElementById('lw-header');
  if (!header) return;
  var update = function () {
    header.classList.toggle('lw-header--slim', window.scrollY > 24);
  };
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
